module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topnav', {
    attrs: {
      "toptype": _vm.toptype
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " animated fadeInUp",
    staticStyle: {
      "background": "#eef1fa",
      "padding-top": "30px",
      "min-height": "600px"
    }
  }, [(_vm.detail) ? _c('div', {
    staticClass: "marginauto",
    staticStyle: {
      "width": "1145px"
    }
  }, [_c('div', {
    staticClass: "bg-white",
    staticStyle: {
      "width": "945px",
      "padding": "20px 100px 50px 100px",
      "border-radius": "10px"
    }
  }, [_c('div', {
    staticClass: "sd_title"
  }, [_c('p', {
    staticClass: "biaoti1"
  }, [_vm._v(_vm._s(_vm.detail.name))]), _vm._v(" "), _c('p', {
    staticClass: "bt_mes",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("\n                        活动时间：" + _vm._s(_vm.detail.active_time) + "\n                    ")]), _vm._v(" "), _c('p', {
    staticClass: "bt_mes",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_vm._v("\n                        活动地址：" + _vm._s(_vm.detail.address) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "sd_content padding-top"
  }, [(_vm.detail.content) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail.content)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.detail.content) ? _c('el-empty', {
    attrs: {
      "description": "暂无详细介绍"
    }
  }) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), _c('callview', {
    attrs: {
      "text": _vm.config.train_detail
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9462e8a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/traindetail.vue
// module id = 419
// module chunks = 1